export class DPaging<T>{
    pagingResult: T[];
    totalCount: number;
    totalPages: number;

    constructor(){
        this.pagingResult=[];
        this.totalCount=0;
        this.totalPages=0;
    }
}